
import { useNavigate } from "react-router-dom";
import { TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Pencil } from "lucide-react";
import { DeleteContactButton } from "../../DeleteContactButton";
import { Employee } from "../types";

interface EmployeeRowProps {
  employee: Employee;
}

export const EmployeeRow = ({ employee }: EmployeeRowProps) => {
  const navigate = useNavigate();
  
  // Format the employee name properly
  const displayName = () => {
    // Debug what we're receiving
    console.log("Employee data:", { 
      first_name: employee.first_name, 
      last_name: employee.last_name,
      email: employee.email,
      id: employee.id
    });
    
    // If we have a name, use it
    if (employee.first_name && employee.last_name) {
      return `${employee.first_name} ${employee.last_name}`;
    } else if (employee.first_name) {
      return employee.first_name;
    } else if (employee.last_name) {
      return employee.last_name;
    }
    
    // If no name data, just display a placeholder with email below
    return "Employee";
  };

  return (
    <TableRow key={employee.id}>
      <TableCell className="font-medium">
        {displayName()}
        {(!employee.first_name && !employee.last_name) && (
          <span className="block text-xs text-gray-500 mt-1">
            {employee.email}
          </span>
        )}
      </TableCell>
      <TableCell className="break-all">{employee.email}</TableCell>
      <TableCell>{employee.phone || "N/A"}</TableCell>
      <TableCell className="capitalize">
        {employee.role || "user"}
      </TableCell>
      <TableCell>
        <div className="flex flex-col space-y-2 items-end">
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate(`/admin/employees/${employee.id}`)}
            className="w-full sm:w-auto"
          >
            <Pencil className="h-4 w-4 mr-2" />
            Edit
          </Button>
          <DeleteContactButton userId={employee.id} />
        </div>
      </TableCell>
    </TableRow>
  );
};
